var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 41,
    viewBox: "0 0 42 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.198 4.48291H6.73884C6.03038 4.48291 5.45801 5.05528 5.45801 5.76374V35.2229C5.45801 35.9313 6.03038 36.5037 6.73884 36.5037H36.198C36.9064 36.5037 37.4788 35.9313 37.4788 35.2229V5.76374C37.4788 5.05528 36.9064 4.48291 36.198 4.48291ZM14.9562 31.7686H10.2051V16.4867H14.9562V31.7686ZM12.5826 14.3973C12.038 14.3973 11.5056 14.2358 11.0527 13.9332C10.5999 13.6307 10.2469 13.2006 10.0385 12.6974C9.83004 12.1942 9.7755 11.6405 9.88176 11.1063C9.98801 10.5721 10.2503 10.0815 10.6354 9.69634C11.0205 9.31121 11.5112 9.04894 12.0454 8.94268C12.5796 8.83643 13.1333 8.89096 13.6365 9.09939C14.1396 9.30782 14.5697 9.66078 14.8723 10.1136C15.1749 10.5665 15.3364 11.0989 15.3364 11.6436C15.3324 13.1645 14.0996 14.3973 12.5826 14.3973ZM32.7437 31.7686H27.9966V24.3358C27.9966 22.5626 27.9646 20.2852 25.527 20.2852C23.0574 20.2852 22.6772 22.2144 22.6772 24.2077V31.7686H17.9341V16.4867H22.4891V18.5761H22.5531C23.1855 17.3753 24.7345 16.1065 27.048 16.1065C31.8591 16.1065 32.7437 19.2725 32.7437 23.3872V31.7686Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.f4c7d6a220822e69518fa38d21e24beb.svg";
export { ForwardRef as ReactComponent };